module.exports = __webpack_public_path__ + "static/media/Fatigue.e4573a8a.png";